import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiList from '@material-ui/core/List';
import MuiListSubheader from '@material-ui/core/ListSubheader';

const List = ({
  dense, disablePadding, subheaderText, children,
}) => {
  // Components props
  let listProps = { dense, disablePadding };
  if (subheaderText) {
    listProps = {
      ...listProps,
      subheader: <MuiListSubheader>{subheaderText}</MuiListSubheader>,
    };
  }

  return (
    <MuiList {...listProps}>
      {children}
    </MuiList>
  );
};

List.propTypes = {
  dense: PropTypes.bool,
  disablePadding: PropTypes.bool,
  subheaderText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.node.isRequired,
};

List.defaultProps = {
  dense: false,
  disablePadding: false,
  subheaderText: null,
};

export default React.memo(List);



// WEBPACK FOOTER //
// ./components/core/List.js